import { render, staticRenderFns } from "./LibraryOverview.vue?vue&type=template&id=58ffa643"
import script from "./LibraryOverview.vue?vue&type=script&lang=js"
export * from "./LibraryOverview.vue?vue&type=script&lang=js"
import style0 from "./LibraryOverview.vue?vue&type=style&index=0&id=58ffa643&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports